import { useCallback, useMemo } from 'react';
import usePath from '../components/Hooks/usePath';
import { useApplicationContext } from '../modules/context/ApplicationContext/ApplicationContext';
import PATHS from '../routes/routes.const';
import useOrderBookStore from '../stores/OrderBook/orderBook.store';

export const useOrderValueVisibility = () => {
  const { isPath } = usePath();
  const { isEnabledHideOrderValue } = useApplicationContext();

  const hideOrderValue = useOrderBookStore((state) => state.hideOrderValue);

  const validateIfCanHideOrderValues = useCallback(() => {
    const canEditOrder = isPath(PATHS.main.orders.editForm.path);
    const isSugestedOrder = isPath(PATHS.main.orders.suggestion.path);
    return canEditOrder || isSugestedOrder;
  }, [isPath]);

  const shouldHideOrderValues = useMemo(
    () => validateIfCanHideOrderValues() && hideOrderValue && isEnabledHideOrderValue,
    [hideOrderValue, isEnabledHideOrderValue, validateIfCanHideOrderValues],
  );

  const showOrderValueVisibilityButton = useMemo(
    () => isEnabledHideOrderValue && validateIfCanHideOrderValues(),
    [isEnabledHideOrderValue, validateIfCanHideOrderValues],
  );

  return {
    shouldHideOrderValues,
    showOrderValueVisibilityButton,
  };
};
